import { render } from "./TotalRevenue.vue?vue&type=template&id=460ba40b&ts=true"
import script from "./TotalRevenue.vue?vue&type=script&lang=ts"
export * from "./TotalRevenue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__